import React, { useState } from 'react';
import { Code, ChevronDown, ChevronRight, Copy, Check } from 'lucide-react';

interface SqlBlockProps {
    sql: string;
}

export const SqlBlock: React.FC<SqlBlockProps> = ({ sql }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [copied, setCopied] = useState(false);

    const handleCopy = async (e: React.MouseEvent) => {
        e.stopPropagation();
        await navigator.clipboard.writeText(sql);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="mt-2 border rounded bg-gray-50">
            <button
                onClick={() => setIsExpanded(!isExpanded)}
                className="w-full flex items-center justify-between px-3 py-2 text-xs text-gray-600 hover:bg-gray-100 transition-colors"
            >
                <div className="flex items-center gap-1.5">
                    {isExpanded ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
                    <Code size={12} />
                    <span>Vis SQL</span>
                </div>
                {isExpanded && (
                    <button
                        onClick={handleCopy}
                        className="flex items-center gap-1 px-2 py-0.5 text-xs text-gray-500 hover:text-gray-700 rounded"
                    >
                        {copied ? <Check size={10} className="text-green-600" /> : <Copy size={10} />}
                        {copied ? 'Kopiert' : 'Kopier'}
                    </button>
                )}
            </button>
            {isExpanded && (
                <div className="px-3 pb-3">
                    <pre className="text-xs font-mono text-gray-700 bg-white p-3 rounded border overflow-x-auto whitespace-pre-wrap">
                        {sql}
                    </pre>
                </div>
            )}
        </div>
    );
};
